import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_auth } from '../zps';

export interface PermissionOption {
  appId: number;
  mask: number;
  langKey: string;
  selected?: boolean;
}

export interface PermissionOptionResponse extends ApiResponse {
  list: PermissionOption[];
}

export interface Permission {
  appId: number;
  permissionCode: number;
}

export interface IUser {
  entid: number;
  extentid?: number;
  gid?: number;
  inUse?: number;
  lang: number;
  type?: number;
  name?: string;
  permissionCode?: number;
  printType?: number;
  reportType?: number;
  region: string;
  permissions?: Permission[];
  email?: string;
  mobile?: string;
  card?: string;
  password?: string;
  pin?: string;
  uid: number | null;
  shops?: number[];
}

export interface IUserUpdate {
  user: IUser;
  currentPassword?: string;
  deletePin?: boolean;
}

export interface IUserResponse extends ApiResponse {
  users: IUser[];
  totalRows: number;
  type: string;
}

export const fetchUser = (entid: number, uid: number): Promise<AxiosResponse<IUserResponse>> => {
  return axios.get<IUserResponse>(`${zps_auth}/api/user?entid=${entid}&uid=${uid}`);
};

export const fetchUsers = (
  controller: AbortController,
  entid: number,
  limit: number,
  offset: number,
  totalRows: boolean,
  name?: string,
  uid?: number,
  sid?: number
): Promise<AxiosResponse<IUserResponse>> => {
  const url =
    `${zps_auth}/api/user?entid=${entid}&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (sid ? `&sid=${sid}` : '') +
    (name ? `&name=${name}` : '') +
    (uid ? `&uid=${uid}` : '');

  return axios.get<IUserResponse>(url, {
    signal: controller.signal
  });
};

export const createUser = (request: IUser, controller: AbortController): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_auth}/api/user`, request, { signal: controller.signal });
};

export const deleteUser = (entid: number, uid: number): Promise<AxiosResponse<ApiResponse>> => {
  return axios.delete<ApiResponse>(`${zps_auth}/api/user?entid=${entid}&uid=${uid}`);
};

export const updateUser = (request: IUserUpdate, controller: AbortController): Promise<AxiosResponse<ApiResponse>> => {
  return axios.put<ApiResponse>(`${zps_auth}/api/user`, request, { signal: controller.signal });
};

export const fetchPermissions = (): Promise<AxiosResponse<PermissionOptionResponse>> => {
  return axios.get<PermissionOptionResponse>(`${zps_auth}/api/user/permission/options`);
};

export const ImportCSVReport = (
  request: { entid: number; file: string },
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_auth}/api/user/file`, request, { signal: controller.signal });
};
